import { useConfirm } from 'primevue/useconfirm';
import { useToast } from 'primevue/usetoast';

export function useConfirmComposable() {
    const confirm = useConfirm();
    const toast = useToast();

    const confirmRequest = (entity, callback, mode = 'delete') => {
        confirm.require({
            header: 'Confirmation',
            message: mode == 'delete' ? 'Are you sure you want to delete it?' : 'Are you sure you want to set it as default?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                callback(entity?.id ?? entity?.key);
            },
            reject: () => {
                toast.add({ severity: 'error', summary: 'Rejected', detail: 'Cancelled', life: 5000 });
            },
        });
    };

    const confirmPopRequest = (event, id, callback) => {
        confirm.require({
            target: event.currentTarget,
            group: 'confirmPopup',
            message: 'Are you sure you want to remove it?',
            icon: 'pi pi-exclamation-triangle',
            accept: async () => {
                await callback(id);
                toast.add({ severity: 'info', summary: 'Success', detail: 'Removed Successfully', life: 5000 });
            },
            reject: () => {
                toast.add({ severity: 'error', summary: 'Rejected', detail: 'Cancelled', life: 5000 });
            },
        });
    };

    const confirmTransfer = (entities, exportflag, callback) => {
        confirm.require({
            header: 'Confirmation',
            message: 'Are you sure you want to transfer these items?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                callback(entities, exportflag);
            },
            reject: () => {
                toast.add({ severity: 'error', summary: 'Rejected', detail: 'Cancelled', life: 5000 });
            },
        });
    };

    return {
        confirmRequest,
        confirmPopRequest,
        confirmTransfer,
    };
}
